// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.premium-card {
  margin: 0 0 18px;
  padding: 16px;
  border: 1px solid var(--palette-border);
  border-radius: var(--r-card);
  background: var(--palette-surface);
}

.premium-card--active {
  border-color: var(--supporter-color, var(--medal-gold));
  background: var(--supporter-soft, #fffaf0);
}

.premium-card--pending {
  border-color: color-mix(in srgb, var(--palette-secondary) 45%, var(--palette-border));
  background: color-mix(in srgb, var(--palette-surface-blue-soft) 45%, white);
}

.premium-card--bronze {
  --supporter-color: var(--medal-bronze);
  --supporter-soft: color-mix(in srgb, var(--medal-bronze) 9%, white);
  --supporter-ink: #6f3f20;
}

.premium-card--silver {
  --supporter-color: var(--medal-silver);
  --supporter-soft: color-mix(in srgb, var(--medal-silver) 10%, white);
  --supporter-ink: #4d5359;
}

.premium-card--gold {
  --supporter-color: var(--medal-gold);
  --supporter-soft: color-mix(in srgb, var(--medal-gold) 9%, white);
  --supporter-ink: #6f5400;
}

.premium-card--loading {
  color: var(--palette-text-muted);
  font-size: 0.85rem;
  text-align: center;
}

.premium-card__head {
  display: flex;
  align-items: center;
  gap: 12px;
}

.premium-card__mark {
  display: flex;
  flex: 0 0 38px;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: 999px;
  background: color-mix(in srgb, var(--supporter-color, #59636f) 15%, white);
}

.premium-card__eyebrow {
  color: var(--supporter-ink, #765a00);
  font-size: 0.66rem;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

.premium-card__title {
  font-family: var(--font-display);
  font-size: 1.12rem;
  font-weight: 600;
  line-height: 1.15;
}

.premium-card__copy,
.premium-card__linked {
  margin: 12px 0 0;
  color: var(--palette-text-muted);
  font-size: 0.84rem;
  line-height: 1.5;
}

.premium-card__linked {
  padding: 10px 12px;
  border-radius: 10px;
  background: var(--palette-surface-alt);
}

.premium-card__actions {
  display: flex;
  flex-direction: column;
  gap: 9px;
  margin-top: 14px;
}

.premium-card__plans {
  min-inline-size: 0;
  margin: 0;
  border: 0;
  padding: 0;
}

.premium-card__plans legend {
  margin-bottom: 8px;
  font-weight: 600;
}

.premium-card__plan {
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 48px;
  color: var(--palette-text);
  cursor: pointer;
}

.premium-card__plan input[type="radio"] {
  flex: 0 0 auto;
  width: 18px;
  height: 18px;
  margin: 0;
}

.premium-card__plan span {
  min-width: 0;
}

.subscription-chooser {
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: #0008;
}

.subscription-chooser__dialog {
  position: relative;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  width: 100%;
  max-width: 460px;
  max-height: calc(100dvh - 32px);
  overflow: hidden;
  padding: 24px;
  border-radius: var(--r-card);
  background: var(--palette-surface);
  color: var(--palette-text);
  font-family: var(--font-ui);
}

.subscription-chooser__dialog h2 {
  flex: 0 0 auto;
  margin: 0 36px 20px 0;
  font-family: var(--font-display);
}

.subscription-chooser__close {
  position: absolute;
  top: 12px;
  right: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border: 0;
  border-radius: 50%;
  color: var(--palette-text);
  background: transparent;
  cursor: pointer;
}

.subscription-chooser__close svg {
  width: 20px;
  height: 20px;
}

.subscription-chooser__description {
  margin: 16px 0;
  font-size: 0.88rem;
  line-height: 1.5;
}

.subscription-chooser__body {
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
}

.subscription-chooser__description p {
  margin: 8px 0;
}

.subscription-chooser__description ul {
  padding-left: 20px;
}

.subscription-chooser__description li + li {
  margin-top: 8px;
}

.subscription-chooser__footer {
  flex: 0 0 auto;
  padding-top: 14px;
}

.subscription-chooser__footer .premium-card__button {
  width: 100%;
}

.premium-card__button {
  display: flex;
  box-sizing: border-box;
  min-height: 48px;
  align-items: center;
  justify-content: center;
  padding-inline: 14px;
  text-decoration: none;
  line-height: 1.25;
  text-align: center;
  white-space: normal;
}

.premium-card__single {
  margin-top: 14px;
}

.premium-card__text-button {
  align-self: center;
  border: 0;
  padding: 4px 8px;
  color: var(--palette-secondary);
  background: transparent;
  font: 600 0.8rem var(--font-ui);
  cursor: pointer;
}

.premium-card__text-button:disabled {
  opacity: 0.45;
  cursor: default;
}

.premium-card__account-link {
  margin: 13px 0 0;
  color: var(--palette-text-muted);
  font-size: 0.8rem;
  line-height: 1.45;
  text-align: center;
}

.premium-card__account-link button {
  border: 0;
  padding: 0;
  color: var(--palette-secondary);
  background: transparent;
  font-family: var(--font-ui);
  font-size: inherit;
  font-weight: 600;
  cursor: pointer;
  text-decoration: underline;
  text-underline-offset: 2px;
}

.premium-card__account-link button:disabled {
  opacity: 0.45;
  cursor: default;
}

.premium-card__patreon-return {
  margin: 12px 0 0;
  font-size: 0.8rem;
  text-align: center;
}

.premium-card__patreon-return a {
  color: var(--palette-secondary);
  font-weight: 600;
  text-underline-offset: 2px;
}

.premium-card__status {
  margin-top: 10px;
  color: var(--palette-text-muted);
  font-size: 0.8rem;
  text-align: center;
}

.settings .premium-card--pending,
.settings .premium-card--active {
  min-height: 260px;
}

.settings .premium-card--pending .premium-card__copy,
.settings .premium-card--active .premium-card__copy {
  min-height: 81px;
}

@media (max-width: 360px) {
  .settings .premium-card--pending,
  .settings .premium-card--active {
    min-height: 280px;
  }

  .settings .premium-card--pending .premium-card__copy,
  .settings .premium-card--active .premium-card__copy {
    min-height: 101px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/screens/components/premiumAccessCard.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,aAAa;EACb,uCAAuC;EACvC,4BAA4B;EAC5B,kCAAkC;AACpC;;AAEA;EACE,uDAAuD;EACvD,0CAA0C;AAC5C;;AAEA;EACE,qFAAqF;EACrF,2EAA2E;AAC7E;;AAEA;EACE,sCAAsC;EACtC,mEAAmE;EACnE,wBAAwB;AAC1B;;AAEA;EACE,sCAAsC;EACtC,oEAAoE;EACpE,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;EACpC,iEAAiE;EACjE,wBAAwB;AAC1B;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,0EAA0E;AAC5E;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,+BAA+B;EAC/B,gBAAgB;EAChB,aAAa;EACb,4BAA4B;EAC5B,kCAAkC;EAClC,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,+BAA+B;EAC/B,uBAAuB;EACvB,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,+BAA+B;EAC/B,uBAAuB;EACvB,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE;;IAEE,iBAAiB;EACnB;;EAEA;;IAEE,iBAAiB;EACnB;AACF","sourcesContent":[".premium-card {\n  margin: 0 0 18px;\n  padding: 16px;\n  border: 1px solid var(--palette-border);\n  border-radius: var(--r-card);\n  background: var(--palette-surface);\n}\n\n.premium-card--active {\n  border-color: var(--supporter-color, var(--medal-gold));\n  background: var(--supporter-soft, #fffaf0);\n}\n\n.premium-card--pending {\n  border-color: color-mix(in srgb, var(--palette-secondary) 45%, var(--palette-border));\n  background: color-mix(in srgb, var(--palette-surface-blue-soft) 45%, white);\n}\n\n.premium-card--bronze {\n  --supporter-color: var(--medal-bronze);\n  --supporter-soft: color-mix(in srgb, var(--medal-bronze) 9%, white);\n  --supporter-ink: #6f3f20;\n}\n\n.premium-card--silver {\n  --supporter-color: var(--medal-silver);\n  --supporter-soft: color-mix(in srgb, var(--medal-silver) 10%, white);\n  --supporter-ink: #4d5359;\n}\n\n.premium-card--gold {\n  --supporter-color: var(--medal-gold);\n  --supporter-soft: color-mix(in srgb, var(--medal-gold) 9%, white);\n  --supporter-ink: #6f5400;\n}\n\n.premium-card--loading {\n  color: var(--palette-text-muted);\n  font-size: 0.85rem;\n  text-align: center;\n}\n\n.premium-card__head {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.premium-card__mark {\n  display: flex;\n  flex: 0 0 38px;\n  align-items: center;\n  justify-content: center;\n  width: 38px;\n  height: 38px;\n  border-radius: 999px;\n  background: color-mix(in srgb, var(--supporter-color, #59636f) 15%, white);\n}\n\n.premium-card__eyebrow {\n  color: var(--supporter-ink, #765a00);\n  font-size: 0.66rem;\n  font-weight: 700;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n}\n\n.premium-card__title {\n  font-family: var(--font-display);\n  font-size: 1.12rem;\n  font-weight: 600;\n  line-height: 1.15;\n}\n\n.premium-card__copy,\n.premium-card__linked {\n  margin: 12px 0 0;\n  color: var(--palette-text-muted);\n  font-size: 0.84rem;\n  line-height: 1.5;\n}\n\n.premium-card__linked {\n  padding: 10px 12px;\n  border-radius: 10px;\n  background: var(--palette-surface-alt);\n}\n\n.premium-card__actions {\n  display: flex;\n  flex-direction: column;\n  gap: 9px;\n  margin-top: 14px;\n}\n\n.premium-card__plans {\n  min-inline-size: 0;\n  margin: 0;\n  border: 0;\n  padding: 0;\n}\n\n.premium-card__plans legend {\n  margin-bottom: 8px;\n  font-weight: 600;\n}\n\n.premium-card__plan {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-height: 48px;\n  color: var(--palette-text);\n  cursor: pointer;\n}\n\n.premium-card__plan input[type=\"radio\"] {\n  flex: 0 0 auto;\n  width: 18px;\n  height: 18px;\n  margin: 0;\n}\n\n.premium-card__plan span {\n  min-width: 0;\n}\n\n.subscription-chooser {\n  position: fixed;\n  inset: 0;\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n  background: #0008;\n}\n\n.subscription-chooser__dialog {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  box-sizing: border-box;\n  width: 100%;\n  max-width: 460px;\n  max-height: calc(100dvh - 32px);\n  overflow: hidden;\n  padding: 24px;\n  border-radius: var(--r-card);\n  background: var(--palette-surface);\n  color: var(--palette-text);\n  font-family: var(--font-ui);\n}\n\n.subscription-chooser__dialog h2 {\n  flex: 0 0 auto;\n  margin: 0 36px 20px 0;\n  font-family: var(--font-display);\n}\n\n.subscription-chooser__close {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 44px;\n  height: 44px;\n  border: 0;\n  border-radius: 50%;\n  color: var(--palette-text);\n  background: transparent;\n  cursor: pointer;\n}\n\n.subscription-chooser__close svg {\n  width: 20px;\n  height: 20px;\n}\n\n.subscription-chooser__description {\n  margin: 16px 0;\n  font-size: 0.88rem;\n  line-height: 1.5;\n}\n\n.subscription-chooser__body {\n  min-height: 0;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n}\n\n.subscription-chooser__description p {\n  margin: 8px 0;\n}\n\n.subscription-chooser__description ul {\n  padding-left: 20px;\n}\n\n.subscription-chooser__description li + li {\n  margin-top: 8px;\n}\n\n.subscription-chooser__footer {\n  flex: 0 0 auto;\n  padding-top: 14px;\n}\n\n.subscription-chooser__footer .premium-card__button {\n  width: 100%;\n}\n\n.premium-card__button {\n  display: flex;\n  box-sizing: border-box;\n  min-height: 48px;\n  align-items: center;\n  justify-content: center;\n  padding-inline: 14px;\n  text-decoration: none;\n  line-height: 1.25;\n  text-align: center;\n  white-space: normal;\n}\n\n.premium-card__single {\n  margin-top: 14px;\n}\n\n.premium-card__text-button {\n  align-self: center;\n  border: 0;\n  padding: 4px 8px;\n  color: var(--palette-secondary);\n  background: transparent;\n  font: 600 0.8rem var(--font-ui);\n  cursor: pointer;\n}\n\n.premium-card__text-button:disabled {\n  opacity: 0.45;\n  cursor: default;\n}\n\n.premium-card__account-link {\n  margin: 13px 0 0;\n  color: var(--palette-text-muted);\n  font-size: 0.8rem;\n  line-height: 1.45;\n  text-align: center;\n}\n\n.premium-card__account-link button {\n  border: 0;\n  padding: 0;\n  color: var(--palette-secondary);\n  background: transparent;\n  font-family: var(--font-ui);\n  font-size: inherit;\n  font-weight: 600;\n  cursor: pointer;\n  text-decoration: underline;\n  text-underline-offset: 2px;\n}\n\n.premium-card__account-link button:disabled {\n  opacity: 0.45;\n  cursor: default;\n}\n\n.premium-card__patreon-return {\n  margin: 12px 0 0;\n  font-size: 0.8rem;\n  text-align: center;\n}\n\n.premium-card__patreon-return a {\n  color: var(--palette-secondary);\n  font-weight: 600;\n  text-underline-offset: 2px;\n}\n\n.premium-card__status {\n  margin-top: 10px;\n  color: var(--palette-text-muted);\n  font-size: 0.8rem;\n  text-align: center;\n}\n\n.settings .premium-card--pending,\n.settings .premium-card--active {\n  min-height: 260px;\n}\n\n.settings .premium-card--pending .premium-card__copy,\n.settings .premium-card--active .premium-card__copy {\n  min-height: 81px;\n}\n\n@media (max-width: 360px) {\n  .settings .premium-card--pending,\n  .settings .premium-card--active {\n    min-height: 280px;\n  }\n\n  .settings .premium-card--pending .premium-card__copy,\n  .settings .premium-card--active .premium-card__copy {\n    min-height: 101px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
